import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M14 13.41H2a.75.75 0 1 1 0-1.5h12a.75.75 0 0 1 0 1.5ZM14.75 8a.74.74 0 0 0-.75-.75H2a.75.75 0 1 0 0 1.5h12a.75.75 0 0 0 .75-.75Zm0-4.67a.74.74 0 0 0-.75-.75H2a.75.75 0 1 0 0 1.5h12a.75.75 0 0 0 .75-.75Z';
const draw24px =
  'M20,19.75H4a.75.75,0,0,1,0-1.5H20a.75.75,0,0,1,0,1.5Zm.75-5.42a.76.76,0,0,0-.75-.75H4a.75.75,0,1,0,0,1.5H20A.75.75,0,0,0,20.75,14.33Zm0-4.66A.75.75,0,0,0,20,8.92H4a.75.75,0,0,0,0,1.5H20A.76.76,0,0,0,20.75,9.67Zm0-4.67A.76.76,0,0,0,20,4.25H4a.75.75,0,0,0,0,1.5H20A.76.76,0,0,0,20.75,5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MenuIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'menu'),
) as IconWithRender;

MenuIcon.displayName = 'MenuIcon';
MenuIcon.propTypes = Icon.propTypes;
MenuIcon.renderIcon = (props) => <MenuIcon {...props} />;
export default MenuIcon;
